import { render } from "./CalendarIcon.vue?vue&type=template&id=1975bd54"
const script = {}

import exportComponent from "/Users/amir/Desktop/movie-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__